function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }

import React from "react";
export default ((_ref) => {
  let {
    styles = {}
  } = _ref,
      props = _objectWithoutProperties(_ref, ["styles"]);

  return <svg width="55" height="55" viewBox="0 0 16 16" {...props}><path d="M8 0c4.411 0 8 3.589 8 8s-3.589 8-8 8-8-3.589-8-8 3.589-8 8-8zm3.165 5.107L6.362 9.246 4.433 7.032l-1.13.986 2.42 2.776.071.072a.75.75 0 0 0 .983.003l5.367-4.626-.98-1.136z" fillRule="evenodd" /></svg>;
});